import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import MoneyServices from '../components/MoneyServices';
import moneyFinancesImg from '../assets/icons/money-finances.webp';

const MoneyFinancesPage = () => {
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }, []);
  return (
    <div className="money-finances-page">
      <Navigation />
      
  <section className="bg-sand text-indigoDeep pt-20 pb-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="font-serif text-5xl lg:text-6xl mb-6 text-indigoDeep">
              <img src={moneyFinancesImg} alt="Money & Finances" className="page-header-icon" />
              Money & Finances
            </h1>
            <p className="text-xl text-grayWarm max-w-3xl mx-auto leading-relaxed">
              Understand your earning potential, investment cycles, and financial destiny. 
              Align your wealth decisions with planetary rhythms for lasting prosperity.
            </p>
          </div>
        </div>
      </section>

      <MoneyServices />

      <Footer />
    </div>
  );
};

export default MoneyFinancesPage;
